<template>
  <div class="profile">
    <v-parallax
      src="@/assets/header-parallax-4.jpg"
      height="200"
      class="page-header"
    >
      <v-container>
        <h1>{{ $t("texts.profile") }}</h1>
      </v-container>
    </v-parallax>
    <profile-detail></profile-detail>
  </div>
</template>

<script>
// @ is an alias to /src
import ProfileDetail from "@/components/ProfileDetail.vue";

export default {
  name: "profile",

  components: {
    ProfileDetail
  }
};
</script>
